// extracted by mini-css-extract-plugin
export default {"container":"with-button_container__DPSix","loader":"with-button_loader__2cDJo"};